"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartBoxClickEnum = void 0;
var EventLabelCartBoxClickEnum;
(function (EventLabelCartBoxClickEnum) {
    EventLabelCartBoxClickEnum["AcceptTermsAndConditions"] = "AcceptTermsAndConditions";
    EventLabelCartBoxClickEnum["SubscribeToNewsletter"] = "SubscribeToNewsletter";
})(EventLabelCartBoxClickEnum || (exports.EventLabelCartBoxClickEnum = EventLabelCartBoxClickEnum = {}));
//# sourceMappingURL=EventLabelCartBoxCLickEnum.js.map